import dayjs from 'dayjs'
import * as c from 'shared/constants'
import { logoutUser, refreshTokens } from 'Store/Auth/actions'

export const requestMiddleware = () => {
  return ({ dispatch, getState }) => next => action => {
    const { request, allowTokenWithoutUser = false } = action
    let auth = getState().auth
    if (!request) {
      return next(action)
    } else if (!auth.refresh) {
      return request(dispatch, getState)
    }

    if (dayjs() > dayjs(auth.refresh.expiration)) {
      dispatch(logoutUser(true))
      return
    }

    const canUseAccessToken = !!auth.user || allowTokenWithoutUser

    // Refresh access token if it has expired
    if (dayjs() > dayjs(auth.access.expiration)) {
      return dispatch(refreshTokens(auth.refresh.token))
        .then(() => {
          auth = getState().auth
          if (!auth.user && !allowTokenWithoutUser) {
            return request(dispatch, getState)
          }
          return request(dispatch, getState, auth.access.token)
        })
        .catch(() => dispatch(logoutUser(true)))
    }

    if (!canUseAccessToken) {
      return request(dispatch, getState)
    }

    return request(dispatch, getState, auth.access.token)
  }
}

export const requestWithAuth = (request, { allowTokenWithoutUser = false } = {}) => {
  return {
    type: c.AUTH_REQUEST,
    allowTokenWithoutUser,
    request: (dispatch, getState, access_token) => request(dispatch, getState, access_token),
  }
}
